export function subscriptionApiBaseUrl(): string {
  const u = import.meta.env.VITE_XQ_API_BASE_URL as string | undefined;
  if (typeof u === "string" && u.trim() !== "") {
    return u.replace(/\/+$/g, "");
  }
  return import.meta.env.PROD ? "/api" : "";
}
